export default __webpack_public_path__ + "static/media/apo_trebur.61b48d24.png";